{
  "name": "tef-coms4p",
  "version": "1.2.0",
  "title": "COMS Micro-Frontend for customer self-service of kernel consents (4p)",
  "description": "COMS Micro-Frontend for customer self-service of kernel consents (4p)",
  "author": {
    "name": "Telefónica Germany GmbH & Co. OHG",
    "email": "u672-coms@telefonica.com"
  },
  "license": "INTERNAL USE ONLY",
  "module": "dist/tef-coms4p.js",
  "type": "module",
  "types": "dist/typings.d.ts",
  "repository": {
    "type": "git",
    "url": "https://mucsggit02.sg.de.pri.o2.com/consent-management/consent-management.git",
    "directory": "micro-frontend-4p"
  },
  "publishConfig": {
    "registry": "https://art02.sg.de.pri.o2.com/artifactory/api/npm/npm-local/"
  },
  "files": [
    "dist/**/*"
  ],
  "keywords": [
    "tef-coms4p",
    "coms",
    "micro-frontend",
    "web component",
    "kernel"
  ],
  "scripts": {
    "install:ci": "npm ci --no-fund --no-audit",
    "preinstall:ci": "npm audit --audit-level=critical --package-lock-only",
    "postinstall:ci": "echo '> npm ci in dependency projects:';node --eval 'console.log(require(\"./tsconfig.json\").references.map(r=>r.path).join(\"\\n\"));' | xargs -I{} sh -c 'cd {}; pwd; npm run install:ci'",
    "dev": "tsx ./scripts/esbuild/dev.ts",
    "dev:docker": "npm run build:docker && npm run dev",
    "build": "tsx ./scripts/esbuild/build.ts && npm run build:docs",
    "build:docker": "npm run build",
    "build:docs": "tsx ./scripts/create-docs.ts",
    "build:serve": "npm run build && npx -y serve -l 4500 dist",
    "prebuild": "rm -rf dist && rm -rf build && mkdir -p dist && mkdir -p build",
    "preversion": "npm run lint && npm test",
    "lint": "npm run lint:lit-analyzer && npm run lint:eslint",
    "lint:eslint": "eslint .",
    "lint:lit-analyzer": "lit-analyzer",
    "lint:fix": "eslint . --fix",
    "test": "npm run test:unit",
    "test:unit": "jest",
    "test:verbose": "jest --verbose",
    "test:ci": "npm run lint && CI=true npm test && npm run test:zipcov",
    "test:zipcov": "zip lcov.zip ./coverage-unit/lcov.info ./coverage-browser/lcov.info"
  },
  "dependencies": {
    "lit": "^3.3.1",
    "normalize-url": "^8.1.0"
  },
  "devDependencies": {
    "@happy-dom/jest-environment": "^20.0.10",
    "@jgoz/esbuild-plugin-typecheck": "^4.0.2",
    "@open-wc/testing-helpers": "^3.0.1",
    "@testing-library/dom": "^10.4.1",
    "@types/jest": "^30.0.0",
    "@types/markdown-it-attrs": "^4.1.3",
    "@types/markdown-it-container": "^2.0.10",
    "@types/markdown-it-emoji": "^3.0.1",
    "@types/mustache": "^4.2.6",
    "@types/node": "^24.6.0",
    "@typescript-eslint/eslint-plugin": "^7.5.0",
    "@typescript-eslint/parser": "^7.5.0",
    "deepmerge-ts": "^7.1.5",
    "esbuild": "^0.25.10",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-lit-css": "^3.0.2",
    "eslint": "^8.57.1",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-import-resolver-typescript": "^3.7.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-lit": "^1.15.0",
    "eslint-plugin-promise": "^7.2.1",
    "eslint-plugin-simple-import-sort": "^12.1.0",
    "eslint-plugin-sonarjs": "^3.0.5",
    "fetch-mock": "^12.5.4",
    "jest": "^30.2.0",
    "jest-extended": "^6.0.0",
    "jest-silent-reporter": "^0.6.0",
    "jose": "^5.9.6",
    "lit-analyzer": "^2.0.3",
    "markdown-it": "^14.1.0",
    "markdown-it-anchor": "^9.2.0",
    "markdown-it-attrs": "^4.3.1",
    "markdown-it-container": "^4.0.0",
    "markdown-it-emoji": "^3.0.0",
    "markdown-it-toc-done-right": "^4.2.0",
    "mustache": "^4.2.0",
    "ts-jest": "^29.4.4",
    "ts-lit-plugin": "^2.0.2",
    "ts-node": "^10.9.2",
    "ts-patch": "^3.3.0",
    "tsx": "^4.20.6",
    "typescript": "^5.9.2",
    "typescript-transform-paths": "^3.5.5",
    "vue": "^2.7.16"
  },
  "overrides": {
    "@typescript-eslint/typescript-estree": "^8.44.0",
    "esbuild-plugin-lit-css": {
      "esbuild": "^0.25.5"
    }
  }
}
